import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

// Suppress CRA error overlay for non-fatal React concurrent rendering warnings
const origError = console.error;
console.error = (...args) => {
  if (typeof args[0] === 'string' && args[0].includes('concurrent rendering')) return;
  origError.apply(console, args);
};

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <App />
);
